import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.fund.item');
import { OnInit, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-fund-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.fund.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageFundItemComponent implements OnInit, DoCheck {
    constructor(@Inject( Service) public service: Service) { }

    public isLoading: boolean = true;
    public status: string = '';
    public id: string = '';
    public menu: string = '';
    public sub: string = '';
    public sub_id: string = '';

    public async ngOnInit() {
        await this.service.init();
        const isAllowed = await this.service.auth.allow(true, "/login");
        if (!isAllowed) return;

        this.status = WizRoute.segment.status;
        this.id = WizRoute.segment.id;
        this.menu = WizRoute.segment.menu;
        this.sub = WizRoute.segment.sub;
        this.sub_id = WizRoute.segment.sub_id;

        this.isLoading = false;

        await this.service.render();

        if (!WizRoute.segment.status)
            return this.service.href("/fund/formed");
        else if (WizRoute.segment.id && !WizRoute.segment.menu)
            return this.service.href(`/fund/${WizRoute.segment.status}/${WizRoute.segment.id}/info`);
    }

    public async ngDoCheck() {
        if (!WizRoute.segment.status)
            return this.service.href("/fund/formed");
        else if (WizRoute.segment.id && !WizRoute.segment.menu)
            return this.service.href(`/fund/${WizRoute.segment.status}/${WizRoute.segment.id}/info`);

        this.status = WizRoute.segment.status;
        this.id = WizRoute.segment.id;
        this.menu = WizRoute.segment.menu;
        this.sub = WizRoute.segment.sub;
        this.sub_id = WizRoute.segment.sub_id;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0;
    }

    public fundNavClass(link: string) {
        if (this.isActive(link)) {
            return "flex items-center gap-2 rounded-lg bg-zinc-100 px-3 py-2 text-sm font-semibold text-zinc-900 transition-colors";
        }
        return "flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900 transition-colors";
    }
}

export default PageFundItemComponent;